// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"fd042bad","528":"aa62317b","596":"4a1837ee","600":"d689cc1c","774":"8ac2307d"}[chunkId] + ".chunk.css";
};